// removed by extract-text-webpack-plugin
module.exports = {"Header":"_3Y1nX","ButtonToggle":"_12SY1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = 946
// module chunks = 0